import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const SHEETALDB = () => {
  const authState = useSelector((state) => state.authReducer);
  const [certificateNumber, setCertificateNumber] = useState("");
  const [certificateData, setCertificateData] = useState(null);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate length
    if (certificateNumber.length !== 16) {
      setIsError(true);
      setMessage("❌ Please enter a valid 16-character Certificate Number.");
      setCertificateData(null);
      return;
    }

    // Mock certificate data
    const mockCertificate = {
      certificateNumber,
      government: "Jharkhand Government",
      departmentName: "PWD",
      employeeName: "Peter Kujur",
      registrationDate: "2025-11-25",
      validity: "2026-11-24",
      empLevel: "Class A",
      remarks: "JH Gov Efficiency Champion, November 2025",
      location: "Raidih Block, Gumla District",
      status: "Active",
    };

    setCertificateData(mockCertificate);
    setMessage("✅ Certificate Found in Think5Whys SAKSHAM Shakti Database.");
    setIsError(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-950 text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-gray-900 border-b border-gray-800 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-xl font-bold text-yellow-300">SHEETAL Champion Database</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-cyan-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 w-8 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-3 py-1 rounded-full bg-cyan-600 text-gray-900 text-sm hover:bg-cyan-500"
              >
                Register
              </button>
            </>
          )}
        </div>

        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-xl text-cyan-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-cyan-300 text-xs lg:text-sm">{userName}</div>
              <div className="flex gap-3">
                <button
                  onClick={handleLogout}
                  className="p-2 mt-4 rounded-md w-8 bg-red-600 hover:bg-red-700"
                >
                  ⏻
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-cyan-300">Login</Link>
              <Link to="/signup" className="text-cyan-300">Register</Link>
            </div>
          )}
        </div>
      )}
      <div className="p-4 bg-black min-h-screen flex-1 items-center justify-center mt-4">
        <p className="mb-2 text-sm lg:text-lg text-white text-center">
          Enter your 16-character Certificate Number
        </p>
        <form onSubmit={handleSubmit} className="flex justify-center mb-2">
          <div className="flex flex-col mt-1 sm:flex-row items-center gap-3 w-full max-w-md">
            <input
              type="text"
              placeholder="Enter Certificate Number"
              value={certificateNumber}
              onChange={(e) => setCertificateNumber(e.target.value.toUpperCase())}
              className="w-full px-4 py-2 text-black border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 text-center tracking-widest"
              maxLength={16}
            />
            <button
              type="submit"
              className="w-full mt-4 sm:w-auto px-6 py-2 bg-pink-600 text-white rounded-lg hover:bg-teal-700 transition"
            >
              Search
            </button>
          </div>
        </form>
        {message && (
          <p
            className={`mt-2 text-center text-sm font-medium ${
              isError ? "text-red-600" : "text-green-600"
            }`}
          >
            {message}
          </p>
        )}

        {certificateData && !isError && (
          <div className="mt-8 bg-black text-blue-800 rounded-xl p-6 shadow-inner border border-gray-200">
            <h4 className="text-lg font-semibold text-yellow-200 mb-4 text-center">
              SHEETAL (Systematic Holistic Efficiency Enhancement Through Administrative Leadership) Certificate Details
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-white">
              <p className="text-white"><strong>Certificate Number:</strong> {certificateData.certificateNumber}</p>
              <p className="text-white"><strong>Government:</strong> {certificateData.government}</p>
              <p className="text-white"><strong>Department Name:</strong> {certificateData.departmentName}</p>
              <p className="text-white"><strong>Employee Name:</strong> {certificateData.employeeName}</p>
              <p className="text-white"><strong>Level/Class:</strong> {certificateData.empLevel}</p>
              <p className="text-white"><strong>Remarks:</strong> {certificateData.remarks}</p>
              <p className="text-white"><strong>Registration Date:</strong> {certificateData.registrationDate}</p>
              <p className="text-white"><strong>Valid Upto:</strong> {certificateData.validity}</p>
              <p className="text-white">
                <strong>Status:</strong>{" "}
                <span className="text-green-600 font-semibold">{certificateData.status}</span>
              </p>
              <p className="sm:col-span-2 text-white">
                <strong>Location:</strong> {certificateData.location}
              </p>
            </div>
          </div>
        )}
      </div>
      <footer className="bg-gray-900 border-t border-gray-800 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-cyan-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-cyan-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-cyan-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-cyan-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SHEETALDB;
